import React from "react"
import {Link} from 'gatsby'
import '../styles/global.css'
import '../styles/block2.css'
import '../styles/header.css'

export default function ContentsHeader(props) {
    
    return (
        
        <div class={props.divClass}>
        
            <h2 class={props.styles} id={props.id}><Link to={props.url}>{props.title}</Link></h2>
        
        </div>    
    );
    
}